import React, { useState, useEffect } from 'react'
import { useLocation, Link } from 'react-router-dom'
import './styles.css'
import Find from '../../share/components/Find/Find'
import CarouselSevices, { servicesTravel } from '../../share/components/CarouselServices/CarouselSevices'
import AsideHotelResult from './aside/AsideHotelResult'
import AllCardsResults from './allResultsCards/AllCardsResults'
import SvgIcon, { iconList } from '../../share/components/iconSVG'
import FilterAsideHotels from './aside/FilterAsideHotels/FilterAsideHotels'
import HotelSearchEngine from '../HotelSearchEngine/HotelSearchEngine'
import UseHotels from '../../../viewModels/hotels/UseHotels'

const HotelResults = () => {

  const [firstRange, setFirstRange] = useState(0)
  const [resetResult, setResetResult] = useState(false)
  const [secondRange, setSecondRange] = useState(0)
  const [errorFilter, setErrorFilter] = useState('')
  const [activeFilterPrice, setActiveFilterPrice] = useState(false)
  const { state } = useLocation()
  const [dropdownFilter, setDropdownFilter] = useState(false)
  const [dropdownSearch, setDropdownSearch] = useState(false)

  const itemsForPage = 10;
  const [dataHotels, setDataHotels] = useState(state.data.slice(0, itemsForPage));
  const [services, setServices] = useState(state.data);
  const [currentPage, setCurrentPage] = useState(0);
  const [mostrarNext, setMostrarNext] = useState(true);

  const nextHandler = () => {
    const totalElementos = services.length;
    const nextPage = currentPage + 1;
    const firstIndex = nextPage * itemsForPage;

    if (firstIndex >= totalElementos) {
      setMostrarNext(false);
      return;
    }

    setCurrentPage(nextPage);
    setDataHotels(services.slice(firstIndex, firstIndex + itemsForPage));
  };

  const prevHandler = () => {
    setMostrarNext(true);
    const prevPage = currentPage - 1;

    if (prevPage < 0) return;

    const firstIndex = prevPage * itemsForPage;

    setDataHotels(services.slice(firstIndex, firstIndex + itemsForPage));
    setCurrentPage(prevPage);
  };


  useEffect(() => {
    if(Number(firstRange) || Number(secondRange) > 0){
      if(services.length > 0){
      setErrorFilter('')
      const filtrados = state.data.filter(item => {
      return item.res.pax[0].hab[0].reg[0]["@attributes"].prr >= firstRange && item.res.pax[0].hab[0].reg[0]["@attributes"].prr <= secondRange
    })
    setDataHotels(filtrados.slice(0, itemsForPage))
    setServices(filtrados)
    }
    }else{
      setErrorFilter('Es necesario llenar los 2 campos')
    }
    
  }, [activeFilterPrice])

  useEffect(() => {
    
    setDataHotels(state.data.slice(0, itemsForPage))
    setServices(state.data)
    setFirstRange(0)
    setSecondRange(0)
  }, [resetResult])
  
 

  return (
    <div className='contain-results-hotels'>
      <Find />
      <CarouselSevices current={servicesTravel[1].title} />
      <div className='contain-route-hotel-result'>
        <p className='route-clinic'> <Link to={'/hotel'}>Hotel</Link> {'>'} <span>Resultados</span></p>
      </div>

      <div className='contain-buttons-mobile-hotels'>
        <button onClick={() => { setDropdownFilter(!dropdownFilter) }}>
          <SvgIcon color={'#004274'} size={30} name={iconList.IconFilters} />
          Filtros
        </button>
        <button onClick={() => { setDropdownSearch(!dropdownSearch) }}>
          <SvgIcon color={'#004274'} size={30} name={iconList.IconSearch} />
          Buscar
        </button>
        {
          dropdownFilter &&
          <FilterAsideHotels widthContain={'300px'} position={'absolute'} />
        }
        {
          dropdownSearch &&
          <HotelSearchEngine titleSize={'20px'} iconTitleSize={'50'} containDateFlexDirection={'column'} containDateJustify={'space-between'} layoutCampoWidth={'100%'} containFinishFlexDirection={'column'} containFinishJustify={'space-between'} layoutCampoVWidth={'100%'} widthContain={'310px'} position={'absolute'} right={'0'} top={'60px'} />
        }
      </div> 

      <div className='main-content-result-hotel'>
        <AsideHotelResult 
          setSecondRange={setSecondRange}
          activeFilterPrice={activeFilterPrice}
          setActiveFilterPrice={setActiveFilterPrice}
          erroFilter={errorFilter}
          setFirstRange={setFirstRange}
          setResetResult={setResetResult}
          resetResult={resetResult}
        />
        <AllCardsResults data={dataHotels} currentPage={currentPage} dataS={services} mostrarNext={mostrarNext} nextHandler={nextHandler} prevHandler={prevHandler}/>
      </div>
    </div>
  )
}

export default HotelResults